export enum Profiles {
  student = 'student',
  mentor = 'mentor',
  employee = 'employee',
  'company-admin' = 'company-admin',
  'mjg-admin' = 'mjg-admin',
  moderator = 'moderator',
  'school-coach' = 'school-coach',
}

export enum Moods {
  default = 'default',
  happy = 'happy',
  surprise = 'surprise',
}

export enum AvatarSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}
